import { render, staticRenderFns } from "./group-info-edit-tab.vue?vue&type=template&id=57a45d42&scoped=true"
import script from "./group-info-edit-tab.vue?vue&type=script&lang=js"
export * from "./group-info-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./group-info-edit-tab.vue?vue&type=style&index=0&id=57a45d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a45d42",
  null
  
)

export default component.exports